export enum EditorHome {
  GET_ALL_TEMPLATE_RULES = "GET_ALL_TEMPLATE_RULES",
  GET_ALL_TEMPLATE_RULES_SUCCESS = "GET_ALL_TEMPLATE_RULES_SUCCESS",
  GET_ALL_TEMPLATE_RULES_FAIL = "GET_ALL_TEMPLATE_RULES_FAIL",

  GET_ALL_TEXT_DATA = "GET_ALL_TEXT_DATA",
  GET_ALL_TEXT_DATA_SUCCESS = "GET_ALL_TEXT_DATA_SUCCESS",
  GET_ALL_TEXT_DATA_FAIL = "GET_ALL_TEXT_DATA_FAIL",

  GET_DATA_ADAPTERS = "GET_DATA_ADAPTERS",
  GET_DATA_ADAPTERS_SUCCESS = "GET_DATA_ADAPTERS_SUCCESS",
  GET_DATA_ADAPTERS_FAIL = "GET_DATA_ADAPTERS_FAIL",

  SAVE_TEMPLATE_CATEGORY = "SAVE_TEMPLATE_CATEGORY",
  SAVE_TEMPLATE_CATEGORY_SUCCESS = "SAVE_TEMPLATE_CATEGORY_SUCCESS",
  SAVE_TEMPLATE_CATEGORY_FAIL = "SAVE_TEMPLATE_CATEGORY_FAIL",

  HANDLE_ADD_CATEGORY_DRAWER = "HANDLE_ADD_CATEGORY_DRAWER",

  UPDATE_CATEGORY_DISPLAY_NAME = "UPDATE_CATEGORY_DISPLAY_NAME",
  UPDATE_CATEGORY_DISPLAY_NAME_SUCCESS = "UPDATE_CATEGORY_DISPLAY_NAME_SUCCESS",
  UPDATE_CATEGORY_DISPLAY_NAME_FAIL = "UPDATE_CATEGORY_DISPLAY_NAME_FAIL",

  GET_CATEGORY_DETAILS = "GET_CATEGORY_DETAILS",
  GET_CATEGORY_DETAILS_SUCCESS = "GET_CATEGORY_DETAILS_SUCCESS",
  GET_CATEGORY_DETAILS_FAIL = "GET_CATEGORY_DETAILS_FAIL",

  GET_ALL_SETTINGS = "GET_ALL_SETTINGS",
  GET_ALL_SETTINGS_SUCCESS = "GET_ALL_SETTINGS_SUCCESS",
  GET_ALL_SETTINGS_FAIL = "GET_ALL_SETTINGS_FAIL",

  UPDATE_SETTINGS = "UPDATE_SETTINGS",
  UPDATE_SETTINGS_SUCCESS = "UPDATE_SETTINGS_SUCCESS",
  UPDATE_SETTINGS_FAIL = "UPDATE_SETTINGS_FAIL",

  ADD_REMOVE_FROM_MESSAGE_TEMPLATES = "ADD_REMOVE_FROM_MESSAGE_TEMPLATES",
  ADD_REMOVE_FROM_MESSAGE_TEMPLATES_SUCCESS = "ADD_REMOVE_FROM_MESSAGE_TEMPLATES_SUCCESS",
  ADD_REMOVE_FROM_MESSAGE_TEMPLATES_FAIL = "ADD_REMOVE_FROM_MESSAGE_TEMPLATES_FAIL",
}
